import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import FiscalGroup from "../entities/pdv/fiscalGroup.entity";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class FiscalGroupDB extends FirestorePipe {
  public static readonly colName = 'FiscalGroups'

  constructor(idEstab: string) {
    if (!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${FiscalGroupDB.colName}`);
  }

  public create(data: FiscalGroup): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: FiscalGroup): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<FiscalGroup[]> {
    return this._getAll<FiscalGroup>(...params);
  }
  public get(id: string): Promise<FiscalGroup> {
    return this._get(id);
  }
  public on(listener: (data: FiscalGroup[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }
}

export default FiscalGroupDB;

